<template>
  <div class="mountain-page">
    <div class="audio-box" @click="controlMusic">
      <img
        v-show="ojAudioPlaying"
        class="audio-on"
        src="../assets/img/music_on.png"
        alt=""
      />
      <img
        v-show="!ojAudioPlaying"
        class="audio-off"
        src="../assets/img/music_off.png"
        alt=""
      />
    </div>

    <div v-show="!visitedAll" @click="hideRoad" class="back-btn" alt="">
      <img
        class="back-btn-txt abs"
        src="../assets/img/back_btn_txt.png"
        alt=""
      />
    </div>
    <img
      v-show="!visitedAll"
      @click="endVisit"
      class="end-btn"
      src="../assets/img/end_btn.png"
      alt=""
    />
    <div class="end-page abs">
      <div class="end-txt abs"></div>
      <!-- <img class="end-txt abs" src="../assets/img/end_txt_qt.png" alt="" /> -->
      <img class="end-page-bg" src="../assets/img/end_page_oj.jpg" alt="" />
    </div>

    <div class="mountain">
      <div class="progress-list-box abs">
        <img class="icon-road abs" src="../assets/img/icon_road2.png" alt="" />
        <div
          :class="[actIndex == item ? 'active' : '', 'progress-item']"
          v-for="item in 14"
          :key="item"
        ></div>
      </div>
      <!-- 永嘉县 -->
      <img
        class="nor-yj-moun1 abs"
        src="../assets/img/nor_yj_moun1.png"
        alt=""
      />
      <div class="moun-box-yj abs">
        <img class="data-moun-yj" src="../assets/img/data_moun_yj.png" alt="" />
        <div class="data-box-yj abs"></div>
      </div>
      <img class="address-yj abs" src="../assets/img/address_yj.png" alt="" />

      <!-- <img class="feature-yj abs" src="../assets/img/feature_yj.jpg" alt="" /> -->
      <div class="feature-yj abs">
        <img
          ref="featureYjGif"
          class="feature-data abs"
          src="../assets/img/feature_yj.gif"
          alt=""
        />
        <img
          class="feature-bg"
          style="width:100%; height: 100%;"
          src="../assets/img/feature_yj_bg.png"
          alt=""
        />
      </div>
      <img class="product-yj abs" src="../assets/img/product_yj.png" alt="" />
      <!-- 永嘉县 -->

      <!-- 文成县 -->
      <img
        class="nor-wc-moun1 abs"
        src="../assets/img/nor_wc_moun1.png"
        alt=""
      />
      <div class="moun-box-wc abs">
        <img class="data-moun-wc" src="../assets/img/data_moun_wc.png" alt="" />
        <div class="data-box-wc abs"></div>
      </div>
      <img class="address-wc abs" src="../assets/img/address_wc.png" alt="" />
      <!-- 文成县 -->

      <!-- 平阳县 -->
      <img
        class="nor-py-moun1 abs"
        src="../assets/img/nor_py_moun1.png"
        alt=""
      />
      <div class="moun-box-py abs">
        <img class="data-moun-py" src="../assets/img/data_moun_py.png" alt="" />
        <div class="data-box-py abs"></div>
      </div>
      <img class="address-py abs" src="../assets/img/address_py.png" alt="" />
      <!-- 平阳县 -->

      <!-- 泰顺县 -->
      <img
        class="nor-ts-moun1 abs"
        src="../assets/img/nor_ts_moun1.png"
        alt=""
      />
      <div class="moun-box-ts abs">
        <img class="data-moun-ts" src="../assets/img/data_moun_ts.png" alt="" />
        <div class="data-box-ts abs"></div>
      </div>
      <img class="address-ts abs" src="../assets/img/address_ts.png" alt="" />
      <!-- 泰顺县 -->

      <!-- 苍南县 -->
      <img
        class="nor-cn-moun2 abs"
        src="../assets/img/nor_cn_moun2.png"
        alt=""
      />
      <img
        class="nor-cn-moun1 abs"
        src="../assets/img/nor_cn_moun1.png"
        alt=""
      />
      <div class="moun-box-cn abs">
        <img class="data-moun-cn" src="../assets/img/data_moun_cn.png" alt="" />
        <div class="data-box-cn abs"></div>
      </div>
      <img class="address-cn abs" src="../assets/img/address_cn.png" alt="" />
      <!-- 苍南县 -->

      <!-- 青田县 -->
      <img
        class="nor-qt-moun1 abs"
        src="../assets/img/nor_qt_moun1.png"
        alt=""
      />
      <div class="moun-box-qt abs">
        <img class="data-moun-qt" src="../assets/img/data_moun_qt.png" alt="" />
        <div class="data-box-qt abs"></div>
      </div>
      <img class="address-qt abs" src="../assets/img/address_qt.png" alt="" />
      <!-- 青田县 -->

      <!-- 莲都区 -->
      <img
        class="nor-ld-moun1 abs"
        src="../assets/img/nor_ld_moun1.png"
        alt=""
      />
      <div class="moun-box-ld abs">
        <img class="data-moun-ld" src="../assets/img/data_moun_ld.png" alt="" />
        <div class="data-box-ld abs"></div>
      </div>
      <img class="address-ld abs" src="../assets/img/address_ld.png" alt="" />
      <!-- 莲都区 -->

      <!-- 云和县 -->
      <img
        class="nor-yh-moun1 abs"
        src="../assets/img/nor_yh_moun1.png"
        alt=""
      />
      <div class="moun-box-yh abs">
        <img class="data-moun-yh" src="../assets/img/data_moun_yh.png" alt="" />
        <div class="data-box-yh abs"></div>
      </div>
      <img class="address-yh abs" src="../assets/img/address_yh.png" alt="" />

      <!-- <img class="feature-yh abs" src="../assets/img/feature_yh.jpg" alt="" /> -->
      <div class="feature-yh abs">
        <img
          ref="featureYhGif"
          class="feature-data abs"
          src="../assets/img/feature_yh.gif"
          alt=""
        />
        <img
          class="feature-bg"
          style="width:100%; height: 100%;"
          src="../assets/img/feature_yh_bg.png"
          alt=""
        />
      </div>
      <img class="product-yh abs" src="../assets/img/product_yh.png" alt="" />
      <!-- 云和县 -->

      <!-- 龙泉县 -->
      <img
        class="nor-lq-moun2 abs"
        src="../assets/img/nor_lq_moun2.png"
        alt=""
      />
      <img
        class="nor-lq-moun1 abs"
        src="../assets/img/nor_lq_moun1.png"
        alt=""
      />
      <div class="moun-box-lq abs">
        <img class="data-moun-lq" src="../assets/img/data_moun_lq.png" alt="" />
        <div class="data-box-lq abs"></div>
      </div>
      <img class="address-lq abs" src="../assets/img/address_lq.png" alt="" />
      <!-- 龙泉县 -->

      <!-- 庆元县 -->
      <img
        class="nor-qy-moun1 abs"
        src="../assets/img/nor_qy_moun1.png"
        alt=""
      />
      <div class="moun-box-qy abs">
        <img class="data-moun-qy" src="../assets/img/data_moun_qy.png" alt="" />
        <div class="data-box-qy abs"></div>
      </div>
      <img class="address-qy abs" src="../assets/img/address_qy.png" alt="" />
      <!-- 庆元县 -->

      <!-- 缙云县 -->
      <img
        class="nor-jy-moun1 abs"
        src="../assets/img/nor_jy_moun1.png"
        alt=""
      />
      <div class="moun-box-jy abs">
        <img class="data-moun-jy" src="../assets/img/data_moun_jy.png" alt="" />
        <div class="data-box-jy abs"></div>
      </div>
      <img class="address-jy abs" src="../assets/img/address_jy.png" alt="" />

      <!-- <img class="feature-jy abs" src="../assets/img/feature_jy.jpg" alt="" /> -->
      <div class="feature-jy abs">
        <img
          ref="featureJyGif"
          class="feature-data abs"
          src="../assets/img/feature_jy.gif"
          alt=""
        />
        <img
          class="feature-bg"
          style="width:100%; height: 100%;"
          src="../assets/img/feature_jy_bg.png"
          alt=""
        />
      </div>
      <img class="product-jy abs" src="../assets/img/product_jy.png" alt="" />
      <!-- 缙云县 -->

      <!-- 松阳县 -->
      <img
        class="nor-sy-moun1 abs"
        src="../assets/img/nor_sy_moun1.png"
        alt=""
      />
      <div class="moun-box-sy abs">
        <img class="data-moun-sy" src="../assets/img/data_moun_sy.png" alt="" />
        <div class="data-box-sy abs"></div>
      </div>
      <img class="address-sy abs" src="../assets/img/address_sy.png" alt="" />

      <!-- <img class="feature-sy abs" src="../assets/img/feature_sy.jpg" alt="" /> -->
      <div class="feature-sy abs">
        <img
          ref="featureSyGif"
          class="feature-data abs"
          src="../assets/img/feature_sy.gif"
          alt=""
        />
        <img
          class="feature-bg"
          style="width:100%; height: 100%;"
          src="../assets/img/feature_sy_bg.png"
          alt=""
        />
      </div>
      <img class="product-sy abs" src="../assets/img/product_sy.png" alt="" />
      <!-- 松阳县 -->

      <!-- 遂昌县 -->
      <img
        class="nor-sc-moun1 abs"
        src="../assets/img/nor_sc_moun1.png"
        alt=""
      />
      <div class="moun-box-sc abs">
        <img class="data-moun-sc" src="../assets/img/data_moun_sc.png" alt="" />
        <div class="data-box-sc abs"></div>
      </div>
      <img class="address-sc abs" src="../assets/img/address_sc.png" alt="" />
      <!-- 遂昌县 -->

      <!-- 景宁县 -->
      <img
        class="nor-jn-moun2 abs"
        src="../assets/img/nor_jn_moun2.png"
        alt=""
      />
      <img
        class="nor-jn-moun1 abs"
        src="../assets/img/nor_jn_moun1.png"
        alt=""
      />
      <div class="moun-box-jn abs">
        <img class="data-moun-jn" src="../assets/img/data_moun_jn.png" alt="" />
        <div class="data-box-jn abs"></div>
      </div>
      <img class="icon-gdp abs" src="../assets/img/icon_gdp_xj.png" alt="" />
      <img class="address-jn abs" src="../assets/img/address_jn.png" alt="" />
      <!-- 景宁县 -->
    </div>
    <div class="scroll-page" id="scrollPageOj">
      <div class="inner-scroll"></div>
    </div>
    <img ref="hand" class="hand abs" src="../assets/img/hand.png" alt="" />
    <img
      ref="handTips"
      class="hand-tips abs"
      src="../assets/img/hand_tips.png"
      alt=""
    />
    <!-- <img
      v-if="showCover"
      class="cover-oj"
      id="coverOj"
      src="../assets/img/cover_oj.jpg"
      alt=""
    /> -->
  </div>
</template>
<script>
import gsap from "gsap";
import { Howl } from "howler";
export default {
  name: "Mountain",
  props: ["visitedAll", "ojAudioPlaying"],
  data() {
    return {
      showCover: true,
      actIndex: 1
    };
  },
  created() {
    this.scrollAudio = new Howl({
      src:
        "https://hw-v.cztv.com/cztv/vod/2022/07/26/83a88af31cb145f1b6d2625b2040f7e4/mp3_64k_mp3.mp3",
      preload: true,
      autoplay: false,
      loop: false
    });
    this.featureAudio = new Howl({
      src:
        "https://hw-v.cztv.com/cztv/vod/2022/07/26/7d2da5535fab4bf39043077881ec1e36/mp3_64k_mp3.mp3",
      preload: true,
      autoplay: false,
      loop: false
    });
  },
  mounted() {
    gsap.to(".mountain-page .hand", { y: -50, duration: 2, repeat: -1 });
    // document.getElementById("coverOj").addEventListener("touchmove", () => {
    //   this.showCover = false;
    // });
    document
      .getElementById("scrollPageOj")
      .addEventListener("touchstart", () => {
        this.$refs.hand.style.display = "none";
        this.$refs.handTips.style.display = "none";
        // this.scrollAudio.play();
        gsap.to(".data-box-jn", {
          width: "100%",
          duration: 1,
          ease: "Power0.easeIn"
        });
      });
    const tl = new gsap.timeline({
      paused: true
    });

    // tl.to(
    //   ".data-box-jn",
    //   { width: "100%", duration: 1, ease: "Power0.easeIn" },
    //   0
    // )
    tl.addLabel("jn")
      .to(
        ".moun-box-jn",
        {
          x: 50,
          y: 550,
          scale: 1.7,
          duration: 1.5,
          ease: "Power0.easeIn"
        },
        "jn+=0.5"
      )
      .to(
        ".nor-jn-moun1",
        { x: -80, y: 500, scale: 1.5, duration: 2 },
        "jn+=0.5"
      )
      .to(
        ".nor-jn-moun2",
        { x: -80, y: 500, scale: 1.5, duration: 2.5 },
        "jn+=0.5"
      )
      .to(".moun-box-sc", { bottom: 0, opacity: 1, duration: 1 }, "jn+=0.5")
      .to(".nor-sc-moun1", { bottom: 0, opacity: 1, duration: 1 }, "jn+=0.5")
      // .to(".data-box-jn", { opacity: 0, duration: 0.2 }, "jn+=0.55")

      .to(".moun-box-sy", { opacity: 0.1, duration: 0.5 }, "jn+=0.6")
      .to(".address-jn", { x: -50, opacity: 0, duration: 0.5 }, "jn+=1")
      .to(
        ".address-sc",
        {
          x: -50,
          opacity: 1,
          duration: 0.5,
          onStart: () => {
            this.actIndex++;
          },
          onReverseComplete: () => {
            this.actIndex--;
          },
          onComplete() {
            gsap.to(".data-box-sc", { width: "100%", duration: 1 });
          }
        },
        "jn+=1.2"
      )
      .to(
        [".moun-box-jn", ".nor-jn-moun1", ".nor-jn-moun2"],
        { opacity: 0, duration: 0.3 },
        "jn+=1.4"
      )
      // .to(".data-box-sc", { width: "100%", duration: 1 }, 2.6)
      .addLabel("sc")

      .to(".moun-box-jy", { opacity: 0.1, duration: 0.5 }, "sc-=0.2")
      .to(".moun-box-sc", { x: 50, y: 550, scale: 1.7, duration: 1.5 }, "sc")
      .to(".nor-sc-moun1", { x: -80, y: 530, scale: 1.5, duration: 2 }, "sc")
      .to(".moun-box-sy", { opacity: 1, duration: 0.4 }, "sc")
      .to(".moun-box-sy", { bottom: 0, duration: 1 }, "sc")
      .to(".nor-sy-moun1", { opacity: 1, duration: 0.3 }, "sc")
      .to(".nor-sy-moun1", { y: 50, duration: 1 }, "sc")
      .to(".address-sc", { x: -100, opacity: 0, duration: 0.5 }, "sc+=0.4")
      .to(
        ".address-sy",
        {
          x: -50,
          opacity: 1,
          duration: 0.5,
          onStart: () => {
            this.actIndex++;
          },
          onReverseComplete: () => {
            this.actIndex--;
          },
          onComplete() {
            gsap.to(".data-box-sy", { width: "100%", duration: 1 });
          }
        },
        "sc+=0.6"
      )
      .to(
        [".moun-box-sc", ".nor-sc-moun1"],
        { opacity: 0, duration: 0.3 },
        "sc+=0.9"
      )
      // .to(".data-box-sy", { width: "100%", duration: 1 }, 4.7)
      .addLabel("sy")

      .from(
        ".product-sy",
        {
          opacity: 0,
          width: 0,
          duration: 0.2,
          onStart: () => {
            this.featureAudio.play();
          }
        },
        "sy-=0.5"
      )
      .to(".product-sy", { opacity: 0, duration: 0.2 }, "sy")
      .from(
        ".feature-sy",
        {
          opacity: 0,
          y: 200,
          onStart: () => {
            this.$refs.featureSyGif.style.display = "block";
          }
        },
        "sy"
      )
      .to(".feature-sy", { opacity: 0, y: -200 }, "sy+=0.6")

      .to(".moun-box-qy", { opacity: 0.1, duration: 0.5 }, "sy-=0.2")
      .to(".moun-box-sy", { x: 50, y: 550, scale: 1.5, duration: 1.5 }, "sy+=1")
      .to(".nor-sy-moun1", { x: -80, y: 530, scale: 1.5, duration: 2 }, "sy+=1")
      .to(".moun-box-jy", { opacity: 1, duration: 0.4 }, "sy+=1")
      .to(".moun-box-jy", { bottom: 0, duration: 1 }, "sy+=1")
      .to(".nor-jy-moun1", { opacity: 1, duration: 0.3 }, "sy+=1")
      .to(".nor-jy-moun1", { y: 50, duration: 1 }, "sy+=1")
      .to(".address-sy", { x: -100, opacity: 0, duration: 0.5 }, "sy+=1.4")
      .to(
        ".address-jy",
        {
          x: -50,
          opacity: 1,
          duration: 0.5,
          onStart: () => {
            this.actIndex++;
          },
          onReverseComplete: () => {
            this.actIndex--;
          },
          onComplete() {
            gsap.to(".data-box-jy", { width: "100%", duration: 1 });
          }
        },
        "sy+=1.6"
      )
      .to(
        [".moun-box-sy", ".nor-sy-moun1"],
        { opacity: 0, duration: 0.3 },
        "sy+=1.9"
      )
      // .to(".data-box-jy", { width: "100%", duration: 1 }, 6.8)
      .addLabel("jy")

      .from(
        ".product-jy",
        {
          opacity: 0,
          width: 0,
          duration: 0.2,
          onStart: () => {
            this.featureAudio.play();
          }
        },
        "jy-=0.5"
      )
      .to(".product-jy", { opacity: 0, duration: 0.2 }, "jy")
      .from(
        ".feature-jy",
        {
          opacity: 0,
          y: 200,
          onStart: () => {
            this.$refs.featureJyGif.style.display = "block";
          }
        },
        "jy"
      )
      .to(".feature-jy", { opacity: 0, y: -200 }, "jy+=0.6")

      .to(".moun-box-lq", { opacity: 0.1, duration: 0.5 }, "jy-=0.2")
      .to(".moun-box-jy", { x: 50, y: 550, scale: 1.7, duration: 1.5 }, "jy+=1")
      .to(".nor-jy-moun1", { x: -80, y: 530, scale: 1.5, duration: 2 }, "jy+=1")
      .to(".moun-box-qy", { opacity: 1, duration: 0.4 }, "jy+=1")
      .to(".moun-box-qy", { bottom: 0, duration: 1 }, "jy+=1")
      .to(".nor-qy-moun1", { opacity: 1, duration: 0.3 }, "jy+=1")
      .to(".nor-qy-moun1", { y: 50, duration: 1 }, "jy+=1")
      .to(".address-jy", { x: -100, opacity: 0, duration: 0.5 }, "jy+=1.5")
      .to(
        ".address-qy",
        {
          x: -50,
          opacity: 1,
          duration: 0.5,
          onStart: () => {
            this.actIndex++;
          },
          onReverseComplete: () => {
            this.actIndex--;
          },
          onComplete() {
            gsap.to(".data-box-qy", { width: "100%", duration: 1 });
          }
        },
        "jy+=1.7"
      )
      .to(
        [".moun-box-jy", ".nor-jy-moun1"],
        { opacity: 0, duration: 0.3 },
        "jy+=1.7"
      )
      // .to(".data-box-qy", { width: "100%", duration: 1 }, 8.7)
      .addLabel("qy")

      .to(".moun-box-yh", { opacity: 0.1, duration: 0.5 }, "qy-=0.2")
      .to(".moun-box-qy", { x: 50, y: 550, scale: 1.7, duration: 1.5 }, "qy")
      .to(".nor-qy-moun1", { x: -80, y: 530, scale: 1.5, duration: 2 }, "qy")
      .to(".moun-box-lq", { opacity: 1, duration: 0.4 }, "qy")
      .to(".moun-box-lq", { bottom: 0, duration: 1 }, "qy")
      .to(".nor-lq-moun1", { opacity: 1, duration: 0.3 }, "qy")
      .to(".nor-lq-moun1", { y: 50, duration: 1 }, "qy")
      .to(".nor-lq-moun2", { opacity: 1, duration: 0.3 }, "qy")
      .to(".nor-lq-moun2", { y: 50, duration: 1 }, "qy")
      .to(".address-qy", { x: -100, opacity: 0, duration: 0.5 }, "qy+=0.5")
      .to(
        ".address-lq",
        {
          x: -50,
          opacity: 1,
          duration: 0.5,
          onStart: () => {
            this.actIndex++;
          },
          onReverseComplete: () => {
            this.actIndex--;
          },
          onComplete() {
            gsap.to(".data-box-lq", { width: "100%", duration: 1 });
          }
        },
        "qy+=0.5"
      )
      .to(
        [".moun-box-qy", ".nor-qy-moun1"],
        { opacity: 0, duration: 0.3 },
        "qy+=0.9"
      )
      // .to(".data-box-lq", { width: "100%", duration: 1 }, 10.8)
      .addLabel("lq")

      .to(".moun-box-ld", { opacity: 0.2, duration: 0.5 }, "lq-=0.2")
      .to(".moun-box-lq", { x: 50, y: 550, scale: 1.7, duration: 1.5 }, "lq")
      .to(".nor-lq-moun1", { x: -80, y: 530, scale: 1.5, duration: 2 }, "lq")
      .to(".nor-lq-moun2", { x: -80, y: 530, scale: 1.5, duration: 2.5 }, "lq")
      .to(".moun-box-yh", { opacity: 1, duration: 0.4 }, "lq")
      .to(".moun-box-yh", { bottom: 0, duration: 1 }, "lq")
      .to(".nor-yh-moun1", { opacity: 1, duration: 0.3 }, "lq")
      .to(".nor-yh-moun1", { y: 50, duration: 1 }, "lq")
      .to(".address-lq", { x: -100, opacity: 0, duration: 0.5 }, "lq+=0.5")
      .to(
        ".address-yh",
        {
          x: -50,
          opacity: 1,
          duration: 0.5,
          onStart: () => {
            this.actIndex++;
          },
          onReverseComplete: () => {
            this.actIndex--;
          },
          onComplete() {
            gsap.to(".data-box-yh", { width: "100%", duration: 1 });
          }
        },
        "lq+=0.5"
      )
      .to(
        [".moun-box-lq", ".nor-lq-moun1"],
        { opacity: 0, duration: 0.3 },
        "lq+=0.9"
      )
      // .to(".data-box-yh", { width: "100%", duration: 1 }, 12.9)
      .addLabel("yh")

      .from(
        ".product-yh",
        {
          opacity: 0,
          width: 0,
          duration: 0.2,
          onStart: () => {
            this.featureAudio.play();
          }
        },
        "yh-=0.5"
      )
      .to(".product-yh", { opacity: 0, duration: 0.2 }, "yh")
      .from(
        ".feature-yh",
        {
          opacity: 0,
          y: 200,
          onStart: () => {
            this.$refs.featureYhGif.style.display = "block";
          }
        },
        "yh"
      )
      .to(".feature-yh", { opacity: 0, y: -400 }, "yh+=0.6")

      .to(".moun-box-qt", { opacity: 0.2, duration: 0.5 }, "yh-=0.2")
      .to(".moun-box-yh", { x: 50, y: 550, scale: 1.7, duration: 1.5 }, "yh+=1")
      .to(".nor-yh-moun1", { x: -80, y: 530, scale: 1.5, duration: 2 }, "yh+=1")
      .to(".moun-box-ld", { opacity: 1, duration: 0.4 }, "yh+=1")
      .to(".moun-box-ld", { bottom: 0, duration: 1 }, "yh+=1")
      .to(".nor-ld-moun1", { opacity: 1, duration: 0.3 }, "yh+=1")
      .to(".nor-ld-moun1", { y: 50, duration: 1 }, "yh+=1")
      .to(".address-yh", { x: -100, opacity: 0, duration: 0.5 }, "yh+=1.5")
      .to(
        ".address-ld",
        {
          x: -50,
          opacity: 1,
          duration: 0.5,
          onStart: () => {
            this.actIndex++;
          },
          onReverseComplete: () => {
            this.actIndex--;
          },
          onComplete() {
            gsap.to(".data-box-ld", { width: "100%", duration: 1 });
          }
        },
        "yh+=1.5"
      )
      .to(
        [".moun-box-yh", ".nor-yh-moun1"],
        { opacity: 0, duration: 0.3 },
        "yh+=1.9"
      )
      // .to(".data-box-ld", { width: "100%", duration: 1 }, 15)
      .addLabel("ld")

      .to(".moun-box-cn", { opacity: 0.2, duration: 0.5 }, "ld-=0.2")
      .to(".moun-box-ld", { x: 50, y: 550, scale: 1.7, duration: 1.5 }, "ld")
      .to(".nor-ld-moun1", { x: -80, y: 530, scale: 1.5, duration: 2 }, "ld")
      .to(".moun-box-qt", { opacity: 1, duration: 0.4 }, "ld")
      .to(".moun-box-qt", { bottom: 0, duration: 1 }, "ld")
      .to(".nor-qt-moun1", { opacity: 1, duration: 0.3 }, "ld")
      .to(".nor-qt-moun1", { y: 50, duration: 1 }, "ld")
      .to(".address-ld", { x: -100, opacity: 0, duration: 0.5 }, "ld+=0.5")
      .to(
        ".address-qt",
        {
          x: -50,
          opacity: 1,
          duration: 0.5,
          onStart: () => {
            this.actIndex++;
          },
          onReverseComplete: () => {
            this.actIndex--;
          },
          onComplete() {
            gsap.to(".data-box-qt", { width: "100%", duration: 1 });
          }
        },
        "ld+=0.5"
      )
      .to(
        [".moun-box-ld", ".nor-ld-moun1"],
        { opacity: 0, duration: 0.3 },
        "ld+=0.9"
      )
      // .to(".data-box-qt", { width: "100%", duration: 1 }, 17.1)
      .addLabel("qt")

      .to(".moun-box-ts", { opacity: 0.2, duration: 0.5 }, "qt-=0.2")
      .to(".moun-box-qt", { x: 50, y: 550, scale: 1.7, duration: 1.5 }, "qt")
      .to(".nor-qt-moun1", { x: -80, y: 530, scale: 1.5, duration: 2 }, "qt")
      .to(".moun-box-cn", { opacity: 1, duration: 0.4 }, "qt")
      .to(".moun-box-cn", { bottom: 0, duration: 1 }, "qt")
      .to(".nor-cn-moun1", { opacity: 1, duration: 0.3 }, "qt")
      .to(".nor-cn-moun1", { y: 50, duration: 1 }, "qt")
      .to(".nor-cn-moun2", { opacity: 1, duration: 0.3 }, "qt")
      .to(".nor-cn-moun2", { y: 50, duration: 1 }, "qt")
      .to(".address-qt", { x: -100, opacity: 0, duration: 0.5 }, "qt+=0.5")
      .to(
        ".address-cn",
        {
          x: -50,
          opacity: 1,
          duration: 0.5,
          onStart: () => {
            this.actIndex++;
          },
          onReverseComplete: () => {
            this.actIndex--;
          },
          onComplete() {
            gsap.to(".data-box-cn", { width: "100%", duration: 1 });
          }
        },
        "qt+=0.5"
      )
      .to(
        [".moun-box-qt", ".nor-qt-moun1"],
        { opacity: 0, duration: 0.3 },
        "qt+=0.9"
      )
      // .to(".data-box-cn", { width: "100%", duration: 1 }, 19.2)
      .addLabel("cn")

      .to(".moun-box-py", { opacity: 0.2, duration: 0.5 }, "cn-=0.2")
      .to(".moun-box-cn", { x: 50, y: 550, scale: 1.7, duration: 1.5 }, "cn")
      .to(".nor-cn-moun1", { x: -80, y: 530, scale: 1.5, duration: 2 }, "cn")
      .to(".nor-cn-moun2", { x: -80, y: 530, scale: 1.5, duration: 2.5 }, "cn")
      .to(".moun-box-ts", { opacity: 1, duration: 0.4 }, "cn")
      .to(".moun-box-ts", { bottom: 0, duration: 1 }, "cn")
      .to(".nor-ts-moun1", { opacity: 1, duration: 0.3 }, "cn")
      .to(".nor-ts-moun1", { y: 50, duration: 1 }, "cn")
      .to(".address-cn", { x: -100, opacity: 0, duration: 0.5 }, "cn+=0.5")
      .to(
        ".address-ts",
        {
          x: -50,
          opacity: 1,
          duration: 0.5,
          onStart: () => {
            this.actIndex++;
          },
          onReverseComplete: () => {
            this.actIndex--;
          },
          onComplete() {
            gsap.to(".data-box-ts", { width: "100%", duration: 1 });
          }
        },
        "cn+=0.5"
      )
      .to(
        [".moun-box-cn", ".nor-cn-moun1"],
        { opacity: 0, duration: 0.3 },
        "cn+=0.9"
      )
      // .to(".data-box-ts", { width: "100%", duration: 1 }, 21.3)
      .addLabel("ts")

      .to(".moun-box-wc", { opacity: 0.2, duration: 0.5 }, "ts-=0.2")
      .to(".moun-box-ts", { x: 50, y: 550, scale: 1.7, duration: 1.5 }, "ts")
      .to(".nor-ts-moun1", { x: -80, y: 530, scale: 1.5, duration: 2 }, "ts")
      .to(".moun-box-py", { opacity: 1, duration: 0.4 }, "ts")
      .to(".moun-box-py", { bottom: 0, duration: 1 }, "ts")
      .to(".nor-py-moun1", { opacity: 1, duration: 0.3 }, "ts")
      .to(".nor-py-moun1", { y: 50, duration: 1 }, "ts")
      .to(".address-ts", { x: -100, opacity: 0, duration: 0.5 }, "ts+=0.5")
      .to(
        ".address-py",
        {
          x: -50,
          opacity: 1,
          duration: 0.5,
          onStart: () => {
            this.actIndex++;
          },
          onReverseComplete: () => {
            this.actIndex--;
          },
          onComplete() {
            gsap.to(".data-box-py", { width: "100%", duration: 1 });
          }
        },
        "ts+=0.5"
      )
      .to(
        [".moun-box-ts", ".nor-ts-moun1"],
        { opacity: 0, duration: 0.3 },
        "ts+=0.9"
      )
      // .to(".data-box-py", { width: "100%", duration: 1 }, 23.4)
      .addLabel("py")

      .to(".moun-box-yj", { opacity: 0.2, duration: 0.5 }, "py-=0.2")
      .to(".moun-box-py", { x: 50, y: 550, scale: 1.7, duration: 1.5 }, "py")
      .to(".nor-py-moun1", { x: -80, y: 530, scale: 1.5, duration: 2 }, "py")
      .to(".moun-box-wc", { opacity: 1, duration: 0.4 }, "py")
      .to(".moun-box-wc", { bottom: 0, duration: 1 }, "py")
      .to(".nor-wc-moun1", { opacity: 1, duration: 0.3 }, "py")
      .to(".nor-wc-moun1", { y: 50, duration: 1 }, "py")
      .to(".address-py", { x: -100, opacity: 0, duration: 0.5 }, "py+=0.5")
      .to(
        ".address-wc",
        {
          x: -50,
          opacity: 1,
          duration: 0.5,
          onStart: () => {
            this.actIndex++;
          },
          onReverseComplete: () => {
            this.actIndex--;
          },
          onComplete() {
            gsap.to(".data-box-wc", { width: "100%", duration: 1 });
          }
        },
        "py+=0.5"
      )
      .to(
        [".moun-box-py", ".nor-py-moun1"],
        { opacity: 0, duration: 0.3 },
        "py+=0.9"
      )
      // .to(".data-box-wc", { width: "100%", duration: 1 }, 25.5)
      .addLabel("wc")

      .to(".moun-box-wc", { x: 50, y: 550, scale: 1.7, duration: 1.5 }, "wc")
      .to(".nor-wc-moun1", { x: -80, y: 530, scale: 1.5, duration: 2 }, "wc")
      .to(".moun-box-yj", { opacity: 1, duration: 0.4 }, "wc")
      .to(".moun-box-yj", { bottom: 0, duration: 1 }, "wc")
      .to(".nor-yj-moun1", { opacity: 1, duration: 0.3 }, "wc")
      .to(".nor-yj-moun1", { y: 50, duration: 1 }, "wc")
      .to(".address-wc", { x: -100, opacity: 0, duration: 0.5 }, "wc+=0.5")
      .to(
        ".address-yj",
        {
          x: -50,
          opacity: 1,
          duration: 0.5,
          onStart: () => {
            this.actIndex++;
          },
          onReverseComplete: () => {
            this.actIndex--;
          },
          onComplete() {
            gsap.to(".data-box-yj", { width: "100%", duration: 1 });
          }
        },
        "wc+=0.5"
      )
      .to(
        [".moun-box-wc", ".nor-wc-moun1"],
        { opacity: 0, duration: 0.3 },
        "wc+=0.9"
      )
      // .to(".data-box-yj", { width: "100%", duration: 1 }, 27.6)
      .addLabel("yj")

      .from(
        ".product-yj",
        {
          opacity: 0,
          width: 0,
          duration: 0.2,
          onStart: () => {
            this.featureAudio.play();
          }
        },
        "yj-=0.5"
      )
      .to(".product-yj", { opacity: 0, duration: 0.2 }, "yj")
      .from(
        ".feature-yj",
        {
          opacity: 0,
          y: 200,
          onStart: () => {
            this.$refs.featureYjGif.style.display = "block";
          }
        },
        "yj"
      )
      .to(".feature-yj", { opacity: 0, y: -200 }, "yj+=0.5")
      .to(
        [".back-btn", ".end-btn"],
        { opacity: 1, duration: 2, display: "block" },
        "yj+=1"
      )
      .to(
        ".end-page",
        {
          opacity: 1,
          duration: 0.5,
          onStart: () => {
            gsap.from(".end-txt", {
              opacity: 0,
              height: 0,
              delay: 0.2,
              duration: 2,
              onComplete: () => {
                if (this.visitedAll) {
                  setTimeout(() => {
                    this.endVisit();
                  }, 2500);
                }
              }
            });
          }
        },
        "yj+=1"
      );

    // tl.play();

    let scrollPage = document.getElementById("scrollPageOj");
    let scrollHeight = scrollPage.scrollHeight;
    let progressHeight = scrollHeight - window.innerHeight;
    let progress, top;
    scrollPage.addEventListener(
      "scroll",
      function() {
        top = scrollPage.scrollTop;
        progress = parseFloat(top / progressHeight);
        // console.log(progress);
        tl.progress(progress);
      },
      false
    );
  },
  methods: {
    hideRoad() {
      this.$emit("hideroad", "oj");
    },
    endVisit() {
      this.$emit("endvisit", "oj");
    },
    controlMusic() {
      this.$emit("playmusic", "oj");
    }
  }
};
</script>
<style lang="less" scoped>
.mountain-page {
  width: 100%;
  height: 100%;
  background-color: #fff;
  position: relative;
  .hand {
    width: 89px;
    height: 90px;
    left: 50%;
    margin-left: -20px;
    bottom: 120px;
    z-index: 5;
  }
  .hand-tips {
    width: 191px;
    height: 58px;
    left: 50%;
    margin-left: -80px;
    bottom: 80px;
    z-index: 5;
  }
  .back-btn {
    background-color: rgba(19, 127, 137, 0.75);
  }
  .end-page {
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    opacity: 0;
    z-index: 5;
    .end-txt {
      width: 512px;
      height: 282px;
      top: 102px;
      left: 50%;
      margin-left: -512/2px;
      background: url("../assets/img/end_txt_oj.png") no-repeat top;
      background-size: 100% auto;
    }
    .end-page-bg {
      width: 100%;
      height: 100%;
    }
  }
  .progress-list-box {
    top: 100px;
    right: 60px;
    z-index: 2;
    .icon-road {
      width: 63px;
      height: 64px;
      top: -64 - 23px;
      left: -21px;
    }
    .progress-item {
      width: 0;
      height: 0;
      border: 8px solid transparent;
      border-bottom: 16px solid rgba(22, 176, 160, 0.25);
      margin-bottom: 7px;
      &.active {
        border-bottom: 16px solid #1aa7c1;
        // background-color: #4890b9;
      }
    }
  }
  .mountain {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    .address-jn {
      width: 105px;
      height: 358px;
      left: 27px;
      top: 25px;
    }
    .icon-gdp {
      width: 172px;
      height: 24px;
      left: 39px;
      bottom: 837px;
    }
    .moun-box-jn {
      width: 750px;
      height: 791px;
      right: 0;
      bottom: 0;
      .data-box-jn {
        width: 0;
        height: 747px;
        left: 22px;
        top: -36px;
        background: url("../assets/img/data_jn.png") no-repeat left top;
        background-size: auto 100%;
        z-index: 5;
      }
      .data-moun-jn {
        width: 100%;
        height: 100%;
      }
    }
    .nor-jn-moun1 {
      width: 750px;
      height: 738px;
      left: 0;
      bottom: 0;
    }
    .nor-jn-moun2 {
      width: 750px;
      height: 914px;
      left: 0;
      bottom: 0;
    }
    .address-sc {
      width: 100px;
      height: 358px;
      left: 105px + 27px;
      top: 25px;
      opacity: 0;
    }
    .moun-box-sc {
      width: 750px;
      height: 801px;
      left: 0;
      bottom: 160px;
      opacity: 0.1;
      .data-moun-sc {
        width: 100%;
        height: 100%;
      }
      .data-box-sc {
        width: 0;
        height: 743px;
        top: -19px;
        left: 23px;
        background: url("../assets/img/data_sc.png") no-repeat left;
        background-size: auto 100%;
      }
    }
    .nor-sc-moun1 {
      width: 750px;
      height: 880px;
      bottom: 80px;
      left: 0;
      opacity: 0;
    }
    .address-sy {
      width: 108px;
      height: 360px;
      top: 25px;
      left: 27px + 100px;
      opacity: 0;
    }
    .moun-box-sy {
      width: 750px;
      height: 791px;
      left: 0;
      bottom: 150px;
      opacity: 0;
      .data-moun-sy {
        width: 100%;
        height: 100%;
      }
      .data-box-sy {
        width: 0;
        height: 745px;
        top: -33px;
        left: 27px;
        background: url("../assets/img/data_sy.png") no-repeat left;
        background-size: auto 100%;
      }
    }
    .nor-sy-moun1 {
      width: 750px;
      height: 843px;
      left: 0;
      bottom: 0px;
      opacity: 0;
    }
    .product-sy {
      width: 577px;
      height: 606px;
      top: 86/1334 * 100%;
      left: 50%;
      // margin-top: -606/2 - 50px;
      // margin-left: -577/2px;
      transform: translateX(-50%);
      // opacity: 0;
      z-index: 5;
    }
    .feature-sy {
      width: 710px;
      height: 985px;
      top: 86/1334 * 100%;
      left: 50%;
      margin-left: -355px;
      opacity: 1;
      z-index: 10;
      box-shadow: 5px 5px 50px rgba(0, 0, 0, 0.2);
      .feature-data {
        width: 634px;
        height: 660px;
        top: 150px;
        left: 43px;
        display: none;
      }
    }
    .address-jy {
      width: 101px;
      height: 357px;
      top: 25px;
      left: 27px + 100px;
      opacity: 0;
    }
    .moun-box-jy {
      width: 750px;
      height: 803px;
      left: 0;
      bottom: 150px;
      opacity: 0;
      .data-moun-jy {
        width: 100%;
        height: 100%;
      }
      .data-box-jy {
        width: 0;
        height: 748px;
        top: -24px;
        left: 21px;
        background: url("../assets/img/data_jy.png") no-repeat left;
        background-size: auto 100%;
      }
    }
    .nor-jy-moun1 {
      width: 750px;
      height: 887px;
      left: 0;
      bottom: 0px;
      opacity: 0;
    }
    .product-jy {
      width: 577px;
      height: 606px;
      top: 86/1334 * 100%;
      left: 50%;
      // margin-top: -606/2 - 50px;
      // margin-left: -577/2px;
      // opacity: 0;
      transform: translateX(-50%);
      z-index: 5;
    }
    .feature-jy {
      width: 710px;
      height: 706px;
      top: 86/1334 * 100%;
      left: 50%;
      margin-left: -355px;
      opacity: 1;
      z-index: 10;
      box-shadow: 5px 5px 50px rgba(0, 0, 0, 0.2);
      .feature-data {
        width: 677px;
        height: 404px;
        top: 197px;
        left: 25px;
        display: none;
      }
    }
    .address-qy {
      width: 109px;
      height: 359px;
      top: 25px;
      left: 27px + 100px;
      opacity: 0;
    }
    .moun-box-qy {
      width: 750px;
      height: 766px;
      left: 0;
      bottom: 150px;
      opacity: 0;
      .data-moun-qy {
        width: 100%;
        height: 100%;
      }
      .data-box-qy {
        width: 0;
        height: 718px;
        top: -32px;
        left: 21px;
        background: url("../assets/img/data_qy.png") no-repeat left;
        background-size: auto 100%;
      }
    }
    .nor-qy-moun1 {
      width: 750px;
      height: 802px;
      left: 0;
      bottom: 0px;
      opacity: 0;
    }
    .address-lq {
      width: 109px;
      height: 362px;
      top: 25px;
      left: 27px + 100px;
      opacity: 0;
    }
    .moun-box-lq {
      width: 750px;
      height: 792px;
      left: 0;
      bottom: 150px;
      opacity: 0;
      .data-moun-lq {
        width: 100%;
        height: 100%;
      }
      .data-box-lq {
        width: 0;
        height: 755px;
        top: -43px;
        left: 22px;
        background: url("../assets/img/data_lq.png") no-repeat left;
        background-size: auto 100%;
      }
    }
    .nor-lq-moun1 {
      width: 750px;
      height: 723px;
      left: 0;
      bottom: 0px;
      opacity: 0;
    }
    .nor-lq-moun2 {
      width: 750px;
      height: 926px;
      left: 0;
      bottom: 0px;
      opacity: 0;
    }
    .address-yh {
      width: 105px;
      height: 353px;
      top: 25px;
      left: 27px + 100px;
      opacity: 0;
    }
    .moun-box-yh {
      width: 750px;
      height: 789px;
      left: 0;
      bottom: 150px;
      opacity: 0;
      .data-moun-yh {
        width: 100%;
        height: 100%;
      }
      .data-box-yh {
        width: 0;
        height: 740px;
        top: -29px;
        left: 25px;
        background: url("../assets/img/data_yh.png") no-repeat left;
        background-size: auto 100%;
      }
    }
    .nor-yh-moun1 {
      width: 750px;
      height: 861px;
      left: 0;
      bottom: 0px;
      opacity: 0;
    }
    .product-yh {
      width: 577px;
      height: 565px;
      top: 86/1334 * 100%;
      left: 50%;
      // margin-top: -565/2 - 50px;
      // margin-left: -577/2px;
      // opacity: 0;
      transform: translateX(-50%);
      z-index: 5;
    }
    .feature-yh {
      width: 710px;
      height: 685px;
      top: 86/1334 * 100%;
      left: 50%;
      margin-left: -355px;
      opacity: 1;
      z-index: 10;
      box-shadow: 5px 5px 50px rgba(0, 0, 0, 0.2);
      .feature-data {
        width: 627px;
        height: 413px;
        top: 176px;
        left: 40px;
        display: none;
      }
    }
    .address-ld {
      width: 107px;
      height: 358px;
      top: 25px;
      left: 27px + 100px;
      opacity: 0;
    }
    .moun-box-ld {
      width: 750px;
      height: 785px;
      left: 0;
      bottom: 150px;
      opacity: 0;
      .data-moun-ld {
        width: 100%;
        height: 100%;
      }
      .data-box-ld {
        width: 0;
        height: 734px;
        top: -28px;
        left: 22px;
        background: url("../assets/img/data_ld.png") no-repeat left;
        background-size: auto 100%;
      }
    }
    .nor-ld-moun1 {
      width: 750px;
      height: 877px;
      left: 0;
      bottom: 0px;
      opacity: 0;
    }
    .address-qt {
      width: 99px;
      height: 359px;
      top: 25px;
      left: 27px + 100px;
      opacity: 0;
    }
    .moun-box-qt {
      width: 750px;
      height: 783px;
      left: 0;
      bottom: 150px;
      opacity: 0;
      .data-moun-qt {
        width: 100%;
        height: 100%;
      }
      .data-box-qt {
        width: 0;
        height: 752px;
        top: -48px;
        left: 20px;
        background: url("../assets/img/data_qt.png") no-repeat left;
        background-size: auto 100%;
      }
    }
    .nor-qt-moun1 {
      width: 750px;
      height: 877px;
      left: 0;
      bottom: 0px;
      opacity: 0;
    }
    .address-cn {
      width: 108px;
      height: 359px;
      top: 25px;
      left: 27px + 100px;
      opacity: 0;
    }
    .moun-box-cn {
      width: 750px;
      height: 745px;
      left: 0;
      bottom: 150px;
      opacity: 0;
      .data-moun-cn {
        width: 100%;
        height: 100%;
      }
      .data-box-cn {
        width: 0;
        height: 715px;
        top: -43px;
        left: 22px;
        background: url("../assets/img/data_cn.png") no-repeat left;
        background-size: auto 100%;
      }
    }
    .nor-cn-moun1 {
      width: 750px;
      height: 764px;
      left: 0;
      bottom: 0px;
      opacity: 0;
    }
    .nor-cn-moun2 {
      width: 750px;
      height: 755px;
      left: 0;
      bottom: 0px;
      opacity: 0;
    }
    .address-ts {
      width: 110px;
      height: 358px;
      top: 25px;
      left: 27px + 100px;
      opacity: 0;
    }
    .moun-box-ts {
      width: 750px;
      height: 777px;
      left: 0;
      bottom: 150px;
      opacity: 0;
      .data-moun-ts {
        width: 100%;
        height: 100%;
      }
      .data-box-ts {
        width: 0;
        height: 723px;
        top: -27px;
        left: 21px;
        background: url("../assets/img/data_ts.png") no-repeat left;
        background-size: auto 100%;
      }
    }
    .nor-ts-moun1 {
      width: 750px;
      height: 859px;
      left: 0;
      bottom: 0px;
      opacity: 0;
    }
    .address-py {
      width: 110px;
      height: 358px;
      top: 25px;
      left: 27px + 100px;
      opacity: 0;
    }
    .moun-box-py {
      width: 750px;
      height: 777px;
      left: 0;
      bottom: 150px;
      opacity: 0;
      .data-moun-py {
        width: 100%;
        height: 100%;
      }
      .data-box-py {
        width: 0;
        height: 723px;
        top: -27px;
        left: 21px;
        background: url("../assets/img/data_py.png") no-repeat left;
        background-size: auto 100%;
      }
    }
    .nor-py-moun1 {
      width: 750px;
      height: 859px;
      left: 0;
      bottom: 0px;
      opacity: 0;
    }
    .address-wc {
      width: 109px;
      height: 356px;
      top: 25px;
      left: 27px + 100px;
      opacity: 0;
    }
    .moun-box-wc {
      width: 750px;
      height: 803px;
      left: 0;
      bottom: 150px;
      opacity: 0;
      .data-moun-wc {
        width: 100%;
        height: 100%;
      }
      .data-box-wc {
        width: 0;
        height: 749px;
        top: -26px;
        left: 22px;
        background: url("../assets/img/data_wc.png") no-repeat left;
        background-size: auto 100%;
      }
    }
    .nor-wc-moun1 {
      width: 750px;
      height: 879px;
      left: 0;
      bottom: 0px;
      opacity: 0;
    }
    .address-yj {
      width: 108px;
      height: 360px;
      top: 25px;
      left: 27px + 100px;
      opacity: 0;
    }
    .moun-box-yj {
      width: 750px;
      height: 778px;
      left: 0;
      bottom: 150px;
      opacity: 0;
      .data-moun-yj {
        width: 100%;
        height: 100%;
      }
      .data-box-yj {
        width: 0;
        height: 742px;
        top: -44px;
        left: 21px;
        background: url("../assets/img/data_yj.png") no-repeat left;
        background-size: auto 100%;
      }
    }
    .nor-yj-moun1 {
      width: 750px;
      height: 881px;
      left: 0;
      bottom: 0px;
      opacity: 0;
    }
    .feature-yj {
      width: 710px;
      height: 714px;
      top: 86/1334 * 100%;
      left: 50%;
      margin-left: -355px;
      opacity: 1;
      z-index: 10;
      box-shadow: 5px 5px 50px rgba(0, 0, 0, 0.2);
      .feature-data {
        width: 576px;
        height: 312px;
        top: 225px;
        left: 85px;
        display: none;
      }
    }
    .product-yj {
      width: 577px;
      height: 606px;
      top: 86/1334 * 100%;
      left: 50%;
      // margin-top: -606/2 - 50px;
      // margin-left: -577/2px;
      // opacity: 0;
      transform: translateX(-50%);
      z-index: 5;
    }
  }
  .scroll-page {
    position: absolute;
    z-index: 10;
    width: 100%;
    height: 100%;
    overflow-y: scroll;
    overflow-x: hidden;
    .inner-scroll {
      width: 100%;
      height: 30000px;
    }
  }
}
@keyframes dataAni {
  from {
    width: 0%;
  }
  to {
    width: 100%;
  }
}
</style>
